module.exports = __webpack_public_path__ + "img/cb3p-r-rr1.db48eec1.gif";